import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import MyAlert from './plugins/MyAlert/MyAlert'
import { db } from './config/firebaseConfig'
import Vuetify from 'vuetify'
import 'vuetify/src/stylus/app.styl'
import es from 'vuetify/es5/locale/es'
import config from '../env'

Vue.use(MyAlert, { maximumAlerts: 3 }, store)
Vue.config.productionTip = false

const companyId = config.VUE_APP_COMPANY_ID

db.collection('clientes').doc(companyId).get().then(async doc => {
  let color = '#0000000'

  if (!store.getters.company && doc.data()) {
    color = doc.data().color
    await store.dispatch('setCompany', doc.data())
  }

  if (store.getters.getCompany) {
    color = store.getters.getCompany.color
  }

  Vue.use(Vuetify, {
    iconfont: 'md',
    theme: {
      primary: color
    },
    lang: {
      locales: { es },
      current: 'es'
    }
  })

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
